import { cloneDeep, isObject } from "lodash-es";
import { getCgiDefaultParamsValueFromHook } from "../../common/schemaUtil";
export function getDebugParams(collection, cgiName) {
  const {
    cgiInfo
  } = collection;
  const cgi = cgiInfo[cgiName];
  if (!cgi) {
    return {
      query: {},
      body: {}
    };
  }
  return cloneDeep(cgi.debugParam || {});
}
export function getObjectJSONString(obj, options = {
  comments: true
}) {
  if (!options.comments || !isObject(obj)) {
    return JSON.stringify(obj, undefined, 2);
  }
  if (isHttpRequestParams(obj)) {
    return `
{
    ${Object.keys(obj).map(key => `${key}:${getObjectJSONStringWithComments(obj[key])}`).join(',\n')}
}
`.trim();
  }
  return getObjectJSONStringWithComments(obj);
}
function getObjectJSONStringWithComments(obj) {
  if (!isObject(obj)) return JSON.stringify(obj, undefined, 2);
  const arr = ['{'];
  Object.entries(obj).forEach(([key, val]) => {
    if (val === undefined) {
      return;
    }
    arr.push(['  // ', key, ':', JSON.stringify(val), ','].join(''));
  });
  arr.push('}');
  return arr.join('\n');
}
function isHttpRequestParams(obj) {
  const list = ['body', 'query', 'headers'];
  return Object.keys(obj).every(key => list.includes(key));
}
function getAllKeywords(keywords) {
  return keywords.reduce((prev, item) => {
    prev.push(item);
    if (item.includes('_')) {
      prev.push(item.replace(/_(\w)/g, (_all, letter) => letter === null || letter === void 0 ? void 0 : letter.toUpperCase()));
    }
    return prev;
  }, []);
}
// 匹配一些常见的分页参数
const pageKeywords = getAllKeywords(['page_no', 'page_index', 'page_idx', 'curr_page', 'index', 'idx']);
const sizeKeywords = getAllKeywords(['limit', 'page_size']);
const pageSuggestions = pageKeywords.map(item => ({
  paramKey: item,
  stateKey: 'page'
}));
const sizeSuggestions = sizeKeywords.map(item => ({
  paramKey: item,
  stateKey: 'size'
}));
const listSuggestions = [{
  paramKey: 'filter',
  stateKey: 'filter'
}, ...pageSuggestions, ...sizeSuggestions];
export function getHttpListParamsStrings(options) {
  const {
    collection,
    cgi,
    protocol
  } = options;
  const {
    query,
    body
  } = getCgiDefaultParamsValueFromHook(collection, cgi);
  const suggestions = cgi === 'list' ? [{
    paramKey: protocol.PAGE,
    stateKey: 'page'
  }, {
    paramKey: protocol.SIZE,
    stateKey: 'size'
  }, {
    paramKey: 'page',
    stateKey: 'page'
  }, {
    paramKey: 'size',
    stateKey: 'size'
  }].concat(listSuggestions) : [listSuggestions[0]];
  const hit = key => {
    const target = suggestions.find(item => item.paramKey === key || key.toLowerCase().endsWith(item.paramKey));
    return target;
  };
  const [queryString, bodyString] = [query, body].map(item => {
    if (isObject(item)) {
      return Object.entries(item).map(([key, value]) => {
        const target = hit(key);
        if (target) {
          // 用户的调试参数和模板的一样,使用使用内置的逻辑
          return `${key}: source.${target.stateKey},`;
        }
        const valueString = isObject(value) ? getObjectJSONString(value) : JSON.stringify(value);
        return `${key}: ${valueString},`;
      });
    }
    return null;
  }).map(item => (item === null || item === void 0 ? void 0 : item.join('\n')) || null);
  return [queryString, bodyString];
}
export function getGetDeleteParams(options, idString = 'id') {
  const {
    collection,
    isHttp,
    cgi
  } = options;
  const spyId = '__@@source_spy_id__';
  let params = '';
  if (isHttp) {
    // http 这里把模板的id参数和用户调试用的参数放一起。
    const {
      query,
      body
    } = getDebugParams(collection, cgi) || {};
    [query, body].forEach(item => {
      if (isObject(item)) {
        item.id = spyId;
      }
    });
    params = getObjectJSONString({
      query,
      body
    }, {
      comments: false
    });
  } else {
    params = getObjectJSONString({
      query: {
        id: spyId
      }
    }, {
      comments: false
    });
  }
  params = params.replaceAll(`"${spyId}"`, idString);
  return params;
}
export function getPickBodyCode(key) {
  const pickBodyCode = `
    // 只提交某些字段
    // body: $utils.pick(${key},['key1','key2']),
    // 某些字段不提交
    // body: $utils.omit(${key},['key1','key2']),
`.trim();
  return pickBodyCode;
}
export const pickFormDataCodeString = getPickBodyCode('source.formData');
export const pickPostDataCodeString = getPickBodyCode('args.postData');
//# sourceMappingURL=code.js.map
